<div class="info-card">
  <div class="card-header">
    <i class="fa-solid fa-building-columns text-green-600"></i>
    <h3>Cuentas desde las que paga</h3>
    <div class="header-tags">
      <button
        pButton
        type="button"
        icon="fa-solid fa-plus"
        label="Agregar"
        class="p-button-sm p-button-outlined"
        (click)="abrirAlta()"
      ></button>
    </div>
  </div>

  <div class="card-content">
    <p-progressSpinner *ngIf="cargando" styleClass="w-2rem h-2rem" aria-label="Cargando las cuentas"></p-progressSpinner>

    <p class="cba-error" *ngIf="!cargando && error">
      {{ error }}
      <button pButton type="button" label="Reintentar" icon="pi pi-refresh" class="p-button-text p-button-sm" (click)="cargar()"></button>
    </p>

    <!--
      El vacío explica PARA QUÉ sirve capturarlas. Sin esa frase, un catálogo en blanco parece un
      campo opcional más y nadie lo llena — y mientras esté vacío la conciliación no puede reconocer
      un depósito que llegue sin referencia.
    -->
    <div class="cba-empty" *ngIf="!cargando && !error && !cuentas.length">
      <i class="fa-solid fa-building-columns"></i>
      <p>Este cliente no tiene cuentas registradas.</p>
      <p class="cba-why">
        Capturarlas permite reconocer sus depósitos <b>aunque lleguen sin referencia</b>: la CLABE de origen lo identifica sola.
      </p>
    </div>

    <ng-container *ngIf="!cargando && !error && cuentas.length">
      <div class="cba-row" *ngFor="let c of activas">
        <div class="cba-main">
          <span class="cba-clabe">{{ formatear(c.clabe) }}</span>
          <span class="cba-meta">
            {{ c.bank || 'banco no capturado' }}
            <ng-container *ngIf="c.holderName"> · {{ c.holderName }}</ng-container>
            · <span class="cba-src">{{ origen(c) }}</span>
          </span>
        </div>
        <button
          pButton
          type="button"
          icon="fa-solid fa-ban"
          class="p-button-sm p-button-text p-button-danger"
          pTooltip="Desactivar. No se borra: los movimientos viejos la siguen necesitando"
          tooltipPosition="left"
          (click)="desactivar(c)"
        ></button>
      </div>

      <!-- Las dadas de baja siguen a la vista, apagadas: explican depósitos de antes. -->
      <div class="cba-row is-off" *ngFor="let c of inactivas">
        <div class="cba-main">
          <span class="cba-clabe">{{ formatear(c.clabe) }}</span>
          <span class="cba-meta">{{ c.bank || 'banco no capturado' }} · desactivada</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<p-dialog
  [(visible)]="mostrarAlta"
  [modal]="true"
  [closable]="!guardando"
  header="Agregar una cuenta del cliente"
  styleClass="cba-dialog"
  [style]="{ width: '480px' }"
>
  <div class="cba-form">
    <p class="cba-lead">La cuenta <b>desde la que el cliente transfiere</b>, no una de las nuestras.</p>

    <label for="cba-clabe">CLABE (18 dígitos)</label>
    <input id="cba-clabe" pInputText [(ngModel)]="clabe" placeholder="012180001234567895" autocomplete="off" />
    <!-- El aviso solo aparece cuando ya escribió algo: regañar un campo vacío es ruido. -->
    <small class="cba-hint" *ngIf="clabe && !clabeValida">Son 18 dígitos. Llevas {{ clabeLimpia.length }}.</small>
    <!--
      El rechazo del servidor, junto al campo que lo causó. El toast lo dice, pero se va a los seis
      segundos y el diálogo se queda abierto con la CLABE culpable a la vista y sin explicación: quien
      la escribió vuelve a darle a Guardar. El conflicto que más importa —«ya es de otro cliente»—
      merece quedarse en pantalla hasta que se corrija.
    -->
    <small class="cba-err" *ngIf="errorAlta">{{ errorAlta }}</small>

    <label for="cba-banco">Banco <span class="cba-opt">(opcional)</span></label>
    <input id="cba-banco" pInputText [(ngModel)]="banco" placeholder="Como lo nombra el estado de cuenta" autocomplete="off" />

    <label for="cba-titular">Titular <span class="cba-opt">(opcional)</span></label>
    <input id="cba-titular" pInputText [(ngModel)]="titular" placeholder="Si no coincide con el nombre del cliente" autocomplete="off" />
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="guardando" (click)="mostrarAlta = false"></button>
    <button
      pButton
      type="button"
      label="Guardar"
      icon="fa-solid fa-check"
      [loading]="guardando"
      [disabled]="guardando || !clabeValida"
      (click)="guardar()"
    ></button>
  </ng-template>
</p-dialog>

<p-toast position="top-right"></p-toast>
